import vue from 'vue'
import i18n from '@/locales'
import scoreSelectPng from '@/assets/images/score_select.png'

const tran = function (initParam) {
  return i18n.t(initParam) as string
}

//不需要题号的题型
export const NOT_NEED_ORDER_TOPIC = [5, 15] //分页和段落说明

//分页题
export const PAGING_TOPIC_TYPE = 15

//提前默认结束语
export const NORMAL_END_WORD = `<p class="ql-align-center" style="text-align: center;"><img src="https://storage.wanyol.com/cem-file-data-pub-test/data_upload/996_1658302206649.png"></p><p style="text-align: center;" class="ql-align-center"><span style="background-color: rgb(255, 255, 255); color: rgb(101, 103, 98);">${tran(
  'survy.pushsuccess'
)}</span></p><p style="text-align: center;" class="ql-align-center"><br></p><p style="text-align: center;" class="ql-align-center"><span style="color: rgb(101, 103, 98);">${tran(
  'survy.timeEnd'
)}</span><span style="color: rgb(101, 103, 98); background-color: rgb(248, 248, 248);"></span></p><p style="text-align: center;" class="ql-align-center"><br></p><p class="ql-align-center"><br></p>`

export const NORMAL_JUMP_WORD = tran('survy.jumPage')

//上一题、下一题默认描述
export const LAST_TOPIC_WORD = tran('survy.frontTopic')
export const NEXT_TOPIC_WORD = tran('survy.nextTopic')

//nps最低、最高分描述
export const NPS_MIN_WORD = tran('survy.vntui')
export const NPS_MAX_WORD = tran('survy.vtui')

//量表题最低、最高分描述
export const SCALE_MIN_WORD = tran('survy.vnSatisfied')
export const SCALE_MAX_WORD = tran('survy.vSatisfied')

//删除错误提示
export const DELETE_ERROR_TIPS = tran('template.associated Settings')
export const DELETE_ERROR_TITLE_TIPS = tran.bind(
  {},
  'template.Unable to delete'
) //直接export常量，切换翻译时会出问题
//保存错误提示
export const SAVE_ERROR_TIPS = tran('survy.savefail')
export const SAVE_ERROR_TITLE_TIPS = tran.bind({}, 'survy.cannosave')
//NPS题型
export const NPS_TOPIC_TYPE = [17, 18]
const china_damain = [
  'cem-survey-test.wanyol.com',
  'cem.myoas.com',
  'cem-survey.myoas.com',
  'cem-test.wanyol.com',
  'localhost'
]
export const TOPIC_DATA =
  // window.env?.country === 'china'
  china_damain.includes(window.location.hostname)
    ? [
        {
          label: tran('survy.purtext'),
          value: '纯显示',
          down: true,
          isTitle: true
        },
        {
          label: tran('survy.purp'),
          value: 5,
          isTitle: false,
          contentComponent: 'SectionContent',
          editComponent: 'SectionEdit',
          thumbnailComponent: 'SectionThumbnail',
          icon: 'icon-icon_tixing_wenziduanla11'
        },
        {
          label: tran('survy.purpag'),
          value: 15,
          isTitle: false,
          contentComponent: 'PageContent',
          editComponent: 'PageEdit',
          thumbnailComponent: 'PageThumbnail',
          icon: 'icon-icon_tixing_fenye11'
        },
        {
          label: tran('survy.givePoint'),
          value: '打分题',
          down: true,
          isTitle: true
        },
        {
          label: tran('survy.NPSTop'),
          value: 17,
          isTitle: false,
          contentComponent: 'NpsContent',
          editComponent: 'NpsEdit',
          thumbnailComponent: 'NpsThumbnail',
          icon: 'icon-icon_tixing_NPSti11'
        },
        {
          label: tran('survy.lineNPSTop'),
          value: 18,
          isTitle: false,
          contentComponent: 'MatrixNpsContent',
          editComponent: 'MatrixNpsEdit',
          thumbnailComponent: 'MatrixNpsThumbnail',
          icon: 'icon-icon_tixing_juzhenNPSti11'
        },
        {
          label: tran('survy.inventoryTop'),
          value: 8,
          isTitle: false,
          contentComponent: 'ScaleContent',
          editComponent: 'ScaleEdit',
          thumbnailComponent: 'ScaleThumbnail',
          icon: 'icon-icon_tixing_liangbiaoti11'
        },
        {
          label: tran('survy.lineInventoryTop'),
          value: 14,
          isTitle: false,
          contentComponent: 'MatrixScaleContent',
          editComponent: 'MatrixScaleEdit',
          thumbnailComponent: 'MatrixScaleThumbnail',
          icon: 'icon-icon_tixing_juzhenliangbiaoti11'
        },
        {
          label: tran('survy.scoreSelect'),
          value: 20,
          isTitle: false,
          contentComponent: 'ScoreRadioContent',
          editComponent: 'ScoreRadioEdit',
          thumbnailComponent: 'ScoreRadioThumbnail',
          icon: scoreSelectPng
        },
        {
          label: tran('survy.chosseTopic'),
          value: '选择题',
          down: true,
          isTitle: true
        },
        {
          label: tran('survy.onechose'),
          value: 1,
          isTitle: false,
          contentComponent: 'RadioContent',
          editComponent: 'RadioEdit',
          thumbnailComponent: 'RadioThumbnail',
          icon: 'icon-icon_tixing_danxuanti11'
        },
        {
          label: tran('survy.mulchose'),
          value: 2,
          isTitle: false,
          contentComponent: 'CheckboxContent',
          editComponent: 'CheckboxEdit',
          thumbnailComponent: 'CheckboxThumbnail',
          icon: 'icon-icon_tixing_duoxuanti11'
        },
        {
          label: tran('survy.selectTop'),
          value: 12,
          isTitle: false,
          contentComponent: 'SelectContent',
          editComponent: 'SelectEdit',
          thumbnailComponent: 'SelectThumbnail',
          icon: 'icon-icon_tixing_xialati11'
        },
        {
          label: tran('survy.lineOnechose'),
          value: 3,
          isTitle: false,
          contentComponent: 'MatrixContent',
          editComponent: 'MatrixEdit',
          thumbnailComponent: 'MatrixRadioThumbnail',
          icon: 'icon-icon_tixing_juzhendanxuanti11'
        },
        {
          label: tran('survy.lineMulchose'),
          value: 9,
          isTitle: false,
          contentComponent: 'MatrixCheckboxContent',
          editComponent: 'MatrixCheckboxEdit',
          thumbnailComponent: 'MatrixCheckboxThumbnail',
          icon: 'icon-icon_tixing_juzhenduoxuanti11'
        },
        {
          label: tran('survy.inputTopic'),
          value: '输入题',
          down: true,
          isTitle: true
        },
        {
          label: tran('survy.fillsupTopic'),
          value: 4,
          isTitle: false,
          contentComponent: 'FillContent',
          editComponent: 'FillEdit',
          thumbnailComponent: 'FillThumbnail',
          icon: 'icon-icon_tixing_tiankongti11'
        },
        {
          label: tran('survy.oneLineTop'),
          value: 10,
          isTitle: false,
          contentComponent: 'SingLineContent',
          editComponent: 'SingLineEdit',
          thumbnailComponent: 'SingLineThumbnail',
          icon: 'icon-icon_tixing_danhangwenbenti11'
        },
        {
          label: tran('survy.mulLineTop'),
          value: 11,
          isTitle: false,
          contentComponent: 'MultiLineContent',
          editComponent: 'MultiLineEdit',
          thumbnailComponent: 'MultiLineThumbnail',
          icon: 'icon-icon_tixing_duohangwenbenti11'
        },
        {
          label: tran('survy.uploadTop'),
          value: 19,
          isTitle: false,
          contentComponent: 'UploadContent',
          editComponent: 'UploadEdit',
          thumbnailComponent: 'UploadThumbnail',
          icon: 'icon-paperclip'
        },
        {
          label: tran('survy.personalInformation'),
          value: '个人信息',
          down: true,
          isTitle: true
        },
        {
          label: tran('survy.cityTopic'),
          value: 21,
          isTitle: false,
          contentComponent: 'CityTopicContent',
          editComponent: 'CityTopicEdit',
          thumbnailComponent: 'CityTopicThumbnail',
          icon: 'icon-icon_huabanfuben'
        },
        {
          label: '手机号',
          value: 22,
          isTitle: false,
          contentComponent: 'PhoneContent',
          editComponent: 'PhoneEdit',
          thumbnailComponent: 'PhoneThumbnail',
          icon: 'icon-shoujihao'
        },
        {
          label: '邮箱',
          value: 23,
          isTitle: false,
          contentComponent: 'EmailContent',
          editComponent: 'EmailEdit',
          thumbnailComponent: 'EmailThumbnail',
          icon: 'icon-youxiang'
        }
      ]
    : [
        {
          label: tran('survy.purtext'),
          value: '纯显示',
          down: true,
          isTitle: true
        },
        {
          label: tran('survy.purp'),
          value: 5,
          isTitle: false,
          contentComponent: 'SectionContent',
          editComponent: 'SectionEdit',
          thumbnailComponent: 'SectionThumbnail',
          icon: 'icon-icon_tixing_wenziduanla11'
        },
        {
          label: tran('survy.purpag'),
          value: 15,
          isTitle: false,
          contentComponent: 'PageContent',
          editComponent: 'PageEdit',
          thumbnailComponent: 'PageThumbnail',
          icon: 'icon-icon_tixing_fenye11'
        },
        {
          label: tran('survy.givePoint'),
          value: '打分题',
          down: true,
          isTitle: true
        },
        {
          label: tran('survy.NPSTop'),
          value: 17,
          isTitle: false,
          contentComponent: 'NpsContent',
          editComponent: 'NpsEdit',
          thumbnailComponent: 'NpsThumbnail',
          icon: 'icon-icon_tixing_NPSti11'
        },
        {
          label: tran('survy.lineNPSTop'),
          value: 18,
          isTitle: false,
          contentComponent: 'MatrixNpsContent',
          editComponent: 'MatrixNpsEdit',
          thumbnailComponent: 'MatrixNpsThumbnail',
          icon: 'icon-icon_tixing_juzhenNPSti11'
        },
        {
          label: tran('survy.inventoryTop'),
          value: 8,
          isTitle: false,
          contentComponent: 'ScaleContent',
          editComponent: 'ScaleEdit',
          thumbnailComponent: 'ScaleThumbnail',
          icon: 'icon-icon_tixing_liangbiaoti11'
        },
        {
          label: tran('survy.lineInventoryTop'),
          value: 14,
          isTitle: false,
          contentComponent: 'MatrixScaleContent',
          editComponent: 'MatrixScaleEdit',
          thumbnailComponent: 'MatrixScaleThumbnail',
          icon: 'icon-icon_tixing_juzhenliangbiaoti11'
        },
        {
          label: tran('survy.scoreSelect'),
          value: 20,
          isTitle: false,
          contentComponent: 'ScoreRadioContent',
          editComponent: 'ScoreRadioEdit',
          thumbnailComponent: 'ScoreRadioThumbnail',
          icon: scoreSelectPng
        },
        {
          label: tran('survy.chosseTopic'),
          value: '选择题',
          down: true,
          isTitle: true
        },
        {
          label: tran('survy.onechose'),
          value: 1,
          isTitle: false,
          contentComponent: 'RadioContent',
          editComponent: 'RadioEdit',
          thumbnailComponent: 'RadioThumbnail',
          icon: 'icon-icon_tixing_danxuanti11'
        },
        {
          label: tran('survy.mulchose'),
          value: 2,
          isTitle: false,
          contentComponent: 'CheckboxContent',
          editComponent: 'CheckboxEdit',
          thumbnailComponent: 'CheckboxThumbnail',
          icon: 'icon-icon_tixing_duoxuanti11'
        },
        {
          label: tran('survy.selectTop'),
          value: 12,
          isTitle: false,
          contentComponent: 'SelectContent',
          editComponent: 'SelectEdit',
          thumbnailComponent: 'SelectThumbnail',
          icon: 'icon-icon_tixing_xialati11'
        },
        {
          label: tran('survy.lineOnechose'),
          value: 3,
          isTitle: false,
          contentComponent: 'MatrixContent',
          editComponent: 'MatrixEdit',
          thumbnailComponent: 'MatrixRadioThumbnail',
          icon: 'icon-icon_tixing_juzhendanxuanti11'
        },
        {
          label: tran('survy.lineMulchose'),
          value: 9,
          isTitle: false,
          contentComponent: 'MatrixCheckboxContent',
          editComponent: 'MatrixCheckboxEdit',
          thumbnailComponent: 'MatrixCheckboxThumbnail',
          icon: 'icon-icon_tixing_juzhenduoxuanti11'
        },
        {
          label: tran('survy.inputTopic'),
          value: '输入题',
          down: true,
          isTitle: true
        },
        {
          label: tran('survy.fillsupTopic'),
          value: 4,
          isTitle: false,
          contentComponent: 'FillContent',
          editComponent: 'FillEdit',
          thumbnailComponent: 'FillThumbnail',
          icon: 'icon-icon_tixing_tiankongti11'
        },
        {
          label: tran('survy.oneLineTop'),
          value: 10,
          isTitle: false,
          contentComponent: 'SingLineContent',
          editComponent: 'SingLineEdit',
          thumbnailComponent: 'SingLineThumbnail',
          icon: 'icon-icon_tixing_danhangwenbenti11'
        },
        {
          label: tran('survy.mulLineTop'),
          value: 11,
          isTitle: false,
          contentComponent: 'MultiLineContent',
          editComponent: 'MultiLineEdit',
          thumbnailComponent: 'MultiLineThumbnail',
          icon: 'icon-icon_tixing_duohangwenbenti11'
        },
        {
          label: tran('survy.uploadTop'),
          value: 19,
          isTitle: false,
          contentComponent: 'UploadContent',
          editComponent: 'UploadEdit',
          thumbnailComponent: 'UploadThumbnail',
          icon: 'icon-paperclip'
        },
        {
          label: tran('survy.personalInformation'),
          value: '个人信息',
          down: true,
          isTitle: true
        },
        {
          label: tran('survy.cityTopic'),
          value: 21,
          isTitle: false,
          contentComponent: 'CityTopicContent',
          editComponent: 'CityTopicEdit',
          thumbnailComponent: 'CityTopicThumbnail',
          icon: 'icon-icon_huabanfuben'
        },
        // {
        //   label: '手机号',
        //   value: 22,
        //   isTitle: false,
        //   contentComponent: 'PhoneContent',
        //   editComponent: 'PhoneEdit',
        //   thumbnailComponent: 'PhoneThumbnail',
        //   icon: 'icon-shoujihao'
        // },
        {
          label: '邮箱',
          value: 23,
          isTitle: false,
          contentComponent: 'EmailContent',
          editComponent: 'EmailEdit',
          thumbnailComponent: 'EmailThumbnail',
          icon: 'icon-youxiang'
        }
      ]

export const STR_TYPE = [
  { label: tran('survy.number'), value: 'number' },
  { label: tran('survy.letter'), value: 'letter' },
  { label: tran('survy.chinese'), value: 'chinese' },
  { label: tran('survy.email'), value: 'email' },
  { label: tran('survy.phone'), value: 'phone' }
]

export const TOPIC_NAME = {
  1: '单选题',
  2: '多选题',
  3: '矩阵单选题',
  4: '填空题',
  5: '文字段落',
  8: '量表题',
  9: '矩阵多选题',
  10: '单行文本题',
  11: '多行文本题',
  12: '下拉题',
  14: '矩阵量表题',
  17: 'NPS题',
  18: '矩阵NPS题'
}

export const TOPIC_MODULE = {
  id: '', //题目id
  topicName: '', //题目名称
  topicType: 1, //题目类型
  orderNum: 1,
  surveyTopicOptionId: '',
  answerContent: '',
  isEditStatus: true,
  isAddStatus: true,
  topicSetting: {
    //题目设置
    topicRemark: '', //题目备注
    // endword: tran('survy.thsans'), //提前答题结束语
    endword: '', //提前答题结束语
    isAllowSubmit: false, //是否可以提前结束答题
    isAllowNull: false, //该题是否可以跳过不答
    maxScore: 10, //（矩阵）量表题的最高打分
    optionLengthMoreThan: '', //选择题最少选择项数
    optionLengthLessThan: '', //选择题最多选择项数
    scoreStyle: 0, //量表题的打分样式，枚举值（0：条形，1：星形）
    textLessThan: '', //填空题最多填写字符数
    maxAppendixNum: 9, //附件题最大上传数量
    topicLabel: '', //题目标签
    isRandomOrder: false, //选项是否随机排列
    isEncryption: false, //文本框内容是否加密
    isReversal: false, //NPS题是否隐藏不确定选项
    format: '', //题目是输入题时的填空格式
    lastPageText: LAST_TOPIC_WORD,
    nextPageText: NEXT_TOPIC_WORD,
    // minScoreDesc: '很不满意',
    // maxScoreDesc: '很满意',
    minScoreDesc: '',
    maxScoreDesc: '',
    isRollback: false,
    customizeOption: 0, //打分题是否展示自定义
    customizeOptionValue: tran('survy.uncertain'), //打分题展示自定义文案
    topicOptionSetting: [
      {
        //选项设置
        optionName: '', //选项name
        optionId: null, //选项ID
        isAddText: false, //是否允许填空
        isRequire: false, //是否必填
        isEncryption: false,
        format: '', //填空格式，枚举示例（number：数字、letter：字母、chinese：中文、email：Email、phone：手机号码）
        isFixedNo: false //是否固定选项
      },
      {
        //选项设置
        optionName: '', //选项name
        optionId: null, //选项ID
        isAddText: false, //是否允许填空
        isRequire: false, //是否必填
        isEncryption: false,
        format: '', //填空格式，枚举示例（number：数字、letter：字母、chinese：中文、email：Email、phone：手机号码）
        isFixedNo: false //是否固定选项
      }
    ]
  },
  matrixTopics: [
    {
      bizId: null,
      customizeOption: 0,
      customizeOptionValue: null,
      id: null,
      matrixTopics: null,
      maxScore: 10,
      orderNum: 1,
      parentId: '',
      topicName: '',
      topicSetting: null,
      topicType: null
    },
    {
      bizId: null,
      customizeOption: 0,
      customizeOptionValue: null,
      id: null,
      matrixTopics: null,
      maxScore: 10,
      orderNum: 2,
      parentId: '',
      topicName: '',
      topicType: null
    }
  ]
}

export const SCORE_TYPE = [
  {
    label: tran('survy.lineshape'),
    value: 0
  },
  {
    label: tran('survy.starshape'),
    value: 1
  }
]

export const NPS_SCORE_TYPE = [
  {
    label: tran('survy.lineshape'),
    value: 0
  },
  {
    label: tran('survy.starshape'),
    value: 1
  },
  {
    label: tran('survy.face'),
    value: 2
  }
]

//分值类型
export const SCORE_NUM_TYPE = [
  {
    label: `1-5${tran('survy.point')}`,
    value: 5
  },
  {
    label: `1-10${tran('survy.point')}`,
    value: 10
  }
]

//输入框字符类型正则判断
export const INPUT_VALUE_TYPE_RULE = {
  number: {
    reg: /^\-?[0-9]+\.?[0-9]*$/,
    name: '数字'
  },
  letter: {
    reg: /^[A-Za-z]+$/,
    name: '字母'
  },
  chinese: {
    reg: /^[\u4e00-\u9fa5]{0,}$/,
    name: '中文'
  },
  email: {
    reg: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
    name: '邮箱'
  },
  phone: {
    reg: china_damain.includes(window.location.hostname)
      ? /^(1)\d{10}$/
      : /^\d+$/,
    name: '手机号'
  }
}

//量标题分值
export const SCALE_MAX_SCORE_TYPE = [
  {
    label: `1-10${tran('survy.point')}`,
    value: 10
  },
  {
    label: `1-5${tran('survy.point')}`,
    value: 5
  }
]
